// extracted by mini-css-extract-plugin
module.exports = {"countdown":"style_countdown__0TNCo","countdownItem":"style_countdownItem___lfhi","time":"style_time__34uJN"};